import React from "react";
import schubertquintent from '../assets/images/schubertquintet.png';
import twitchvschat from '../assets/images/twitchvschat.png';
import ballfetch from '../assets/images/ballfetch.png';
import dawgfight from '../assets/images/dawgfight.png';
import broombattle from '../assets/images/broombattle.png';
import autoduo from '../assets/images/autoduo.png';
import pokemon6v6 from '../assets/images/pokemon6v6.png';
import akatsuki from '../assets/images/akatsuki.png';
import winequality from '../assets/images/winequality.png';
import castleclimbknights from '../assets/images/castleclimbknights.png';
import '../assets/styles/Project.scss';
import { useTranslation } from 'react-i18next';


function Project() {
        const {t} = useTranslation();
    return(
    <div className="projects-container" id="projects">
        <h1>{t('personalProjects')}</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://castleclimb.com/" target="_blank" rel="noreferrer"><img src={castleclimbknights} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://castleclimb.com/" target="_blank" rel="noreferrer"><h2>{t('castleClimb')}</h2></a>
                <p>{t('castleClimbDescription')}</p>
                <p>{t('castleClimbDetails')}</p>
            </div>
            <div className="project">
                <a href="https://drive.google.com/drive/folders/1VBPx7Gn0Aye5zkUgMlZuvMrpzWm_lvyT?usp=drive_link" target="_blank" rel="noreferrer"><img src={akatsuki} className="zoom" alt="thumbnail"  height="63%" width="110%"/></a>
                <a href="https://drive.google.com/drive/folders/1VBPx7Gn0Aye5zkUgMlZuvMrpzWm_lvyT?usp=drive_link" target="_blank" rel="noreferrer"><h2>{t('redMoon')}</h2></a>
                <p>{t('redMoonDescription')}</p>
            </div>
            <div className="project">
                <a href="https://drive.google.com/file/d/1uE7oMe6VasnBMgng0cZ-b4UJF8gRuGiH/view?usp=sharing" target="_blank" rel="noreferrer"><img src={pokemon6v6} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://drive.google.com/file/d/1uE7oMe6VasnBMgng0cZ-b4UJF8gRuGiH/view?usp=sharing" target="_blank" rel="noreferrer"><h2>{t('pokemon6v6')}</h2></a>
                <p>{t('pokemon6v6')}</p>
            </div>
            <div className="project">
                <a href="https://github.com/Falco830/ProjectRepository/tree/master/DuolingoHiragana1Auto" target="_blank" rel="noreferrer"><img src={autoduo} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/Falco830/ProjectRepository/tree/master/DuolingoHiragana1Auto" target="_blank" rel="noreferrer"><h2>{t('autoDuo')}</h2></a>
                <p>{t('autoDuoDescription')}</p>
            </div>
        </div>
        <h1>{t('smallerProjects')}</h1>
        <div className="projects-grid">
            <div className="project">
                <a href="https://github.com/Falco830/PredictingWineQualityModel" target="_blank" rel="noreferrer"><img src={winequality} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://github.com/Falco830/PredictingWineQualityModel" target="_blank" rel="noreferrer"><h2>{t('predictingWineQuality')}</h2></a>
                <p>{t('predictingWineQualityDescription')}</p>
            </div>
            <div className="project">
                <a href="https://www.youtube.com/watch?v=YTirkFz9Zy4" target="_blank" rel="noreferrer"><img src={broombattle} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.youtube.com/watch?v=YTirkFz9Zy4" target="_blank" rel="noreferrer"><h2>{t('broomBattle')}</h2></a>
                <p>{t('broomBattleDescription')}</p>
            </div>
            <div className="project">
                <a href="https://www.youtube.com/watch?v=cnskVfS7R-Y" target="_blank" rel="noreferrer"><img src={dawgfight} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.youtube.com/watch?v=cnskVfS7R-Y" target="_blank" rel="noreferrer"><h2>{t('dawgFight')}</h2></a>
                <p>{t('dawgFightDescription')}</p>
            </div>
            <div className="project">
                <a href="https://www.youtube.com/watch?v=04g_FLuIJPI" target="_blank" rel="noreferrer"><img src={ballfetch} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.youtube.com/watch?v=04g_FLuIJPI" target="_blank" rel="noreferrer"><h2>{t('ballFetch')}</h2></a>
                <p>{t('ballFetchDescription')}</p>
            </div>
            <div className="project">
                <a href="https://www.youtube.com/watch?v=-jNuMmURme4&ab_channel=CraftedMovie" target="_blank" rel="noreferrer"><img src={twitchvschat} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.youtube.com/watch?v=-jNuMmURme4&ab_channel=CraftedMovie" target="_blank" rel="noreferrer"><h2>{t('twitchChatVsPlayer')}</h2></a>
                <p>{t('twitchChatVsPlayerDescription')}</p>
            </div>
            <div className="project">
                <a href="https://www.youtube.com/watch?v=AkqjxLbT5Ek" target="_blank" rel="noreferrer"><img src={schubertquintent} className="zoom" alt="thumbnail" width="100%"/></a>
                <a href="https://www.youtube.com/watch?v=AkqjxLbT5Ek" target="_blank" rel="noreferrer"><h2>{t('schubertCelloQuintet')}</h2></a>
                <p>{t('schubertCelloQuintetDescription')}</p>
            </div>
            </div>
    </div>
    );
}

export default Project;